import { ErrorCode } from './OPGPlayerInstance';
import { VIDEO_EVENTS } from 'playable';
function toErrorEvent(_ref) {
  let {
    errorType,
    streamSrc
  } = _ref;
  const err = {
    name: errorType,
    message: `Error playing stream ${streamSrc}`,
    code: ErrorCode.UNKNOWN
  };
  switch (errorType) {
    case 'error-src-parse':
      err.code = ErrorCode.ERROR_SRC_PARSE;
      break;
  }
  return err;
}
export class PlayableWrapper {
  constructor(player) {
    this.player = player;
  }
  on(event, cb) {
    switch (event) {
      case VIDEO_EVENTS.CURRENT_TIME_UPDATED:
        this.onTimeUpdate(cb);
        break;
      case VIDEO_EVENTS.ERROR:
        this.onErrorHandler(cb);
        break;
      default:
        throw new Error(`event ${event} not supported`);
    }
  }
  onTimeUpdate(cb) {
    var _this$player$on, _this$player;
    (_this$player$on = (_this$player = this.player).on) == null || _this$player$on.call(_this$player, VIDEO_EVENTS.CURRENT_TIME_UPDATED, () => {
      var _this$player$getDurat, _this$player2, _this$player$getCurre, _this$player3;
      const duration = ((_this$player$getDurat = (_this$player2 = this.player).getDuration) == null ? void 0 : _this$player$getDurat.call(_this$player2)) || 0;
      const seconds = ((_this$player$getCurre = (_this$player3 = this.player).getCurrentTime) == null ? void 0 : _this$player$getCurre.call(_this$player3)) || 0;
      const percent = duration > 0 ? seconds / duration : 0;
      cb({
        duration,
        percent,
        seconds
      });
    });
  }
  onErrorHandler(cb) {
    var _this$player$on2, _this$player4;
    (_this$player$on2 = (_this$player4 = this.player).on) == null || _this$player$on2.call(_this$player4, VIDEO_EVENTS.ERROR, error => {
      cb(toErrorEvent(error));
    });
  }
}
//# sourceMappingURL=PlayableWrapper.js.map